import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import OutputDetails from 'components/reports/OutputDetails'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function MultipleSclerosisDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Multiple Sclerosis Specific Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>Please provide date of diagnosis and presenting symptoms:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.diagnosis.referToAttachments}>
                        <Question>Date of Diagnosis:</Question>
                        <p>{formatDateMonthYear(questions.diagnosis.subQuestions.dateOfDiagnosis)}</p>

                        <Question>Presenting symptoms:</Question>
                        <p>{questions.diagnosis.subQuestions.presentingSymptoms}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='2'>
                    <Question>Exact type of Multiple Sclerosis?</Question >
                    <ReferrableQuestionWrapper isReferred={questions.exactTypeOfMS.referToAttachments}>
                        <p>{questions.exactTypeOfMS.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='3'>
                    <Question>Date of last attack/flare up?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.recentFlareUps.referToAttachments}>
                        <p>{formatDateMonthYear(questions.recentFlareUps.subQuestions.dateOfLastFlareUp)}</p>

                        <Question>Frequency/Duration of relapses:</Question>
                        <p>{questions.recentFlareUps.subQuestions.relapseDurationFrequency}</p>

                        <Question>Is patient currently symptomatic?</Question>
                        <p>{questions.recentFlareUps.subQuestions.isSymptomatic}</p>

                        {questions.recentFlareUps.subQuestions.isSymptomatic === 'Yes' && (
                            <>
                                <Question>If yes, please provide nature of symptoms:</Question>
                                <p>{questions.recentFlareUps.subQuestions.isSymptomaticDetails}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Please provide dates of all recorded attacks and flare ups:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.allFlareUps.referToAttachments}>
                        <OutputDetails
                            details={questions.allFlareUps.details}
                        />
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Degree of disability?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.degreeOfDisability.referToAttachments}>
                        <p>{questions.degreeOfDisability.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='6'>
                    <Question>Please provide details of treatment and any changes in treatment in the last 2 years:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.treatmentDetails.referToAttachments}>
                        <p>{questions.treatmentDetails.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='7'>
                    <Question>Are there any other factors or co-morbidities present which may influence the prognosis of this condition?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyOtherFactors.referToAttachments}>
                        <p>{questions.anyOtherFactors.value}</p>
                        {questions.anyOtherFactors.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details:</Question>
                                <p>{questions.anyOtherFactors.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}